import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | Manav Adhikar Forum</title>
        <meta
          name="description"
          content="Terms and Conditions for using the Manav Adhikar Forum website."
        />
        <meta
          name="keywords"
          content="Manav Adhikar Forum, terms and conditions, human rights, equality, justice, India, MAF, awareness, campaigns"
        />
        <link
          rel="canonical"
          href="https://manavadhikarforum.in/Terms-and-Conditions"
        />
      </Helmet>
      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="shadow-sm">
              <Card.Header
                as="h1"
                className="text-center bg-primary text-white"
              >
                Terms and Conditions
              </Card.Header>
              <Card.Body>
                <p className="lead text-center text-muted fw-medium">
                  Manav Adhikar Forum - A Human Rights NGO
                </p>
                <hr />

                <h4 className="mt-4">
                  1. Introduction and Acceptance of Terms
                </h4>
                <p>
                  Welcome to the Manav Adhikar Forum website. These Terms and
                  Conditions ("Terms") govern your use of our website at
                  www.manavadhikarforum.in and any related services. By
                  accessing or using this website, you agree to be bound by
                  these Terms and all applicable laws and regulations. If you do
                  not agree with any of these Terms, you are prohibited from
                  using or accessing this site.
                </p>

                <h4 className="mt-4">2. Intellectual Property Rights</h4>
                <p>
                  The content, features, and functionality on this website,
                  including but not limited to all text, graphics, logos, icons,
                  images, audio clips, digital downloads, and data compilations,
                  are the exclusive property of Manav Adhikar Forum or its
                  content suppliers and are protected by Indian and
                  international copyright laws.
                </p>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>Limited License:</strong> You are granted a limited,
                    non-exclusive, non-transferable license to access and use
                    the website for personal, non-commercial purposes. You may
                    not modify, copy, distribute, transmit, display, perform,
                    reproduce, publish, license, create derivative works from,
                    transfer, or sell any information or content obtained from
                    this website without our prior written consent.
                  </ListGroup.Item>
                </ListGroup>

                <h4 className="mt-4">3. User Conduct</h4>
                <p>
                  You agree to use the website only for lawful purposes. You are
                  strictly prohibited from:
                </p>
                <ListGroup>
                  <ListGroup.Item>
                    Violating any applicable local, national, or international
                    law or regulation.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Engaging in any conduct that is harassing, threatening,
                    defamatory, or obscene.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Transmitting any unsolicited or unauthorized advertising or
                    promotional material.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Introducing viruses, Trojan horses, worms, logic bombs, or
                    other malicious or technologically harmful material.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Attempting to gain unauthorized access to our website,
                    servers, or any associated databases.
                  </ListGroup.Item>
                </ListGroup>

                <h4 className="mt-4">
                  4. Donations and Financial Transactions
                </h4>
                <p>
                  Donations made through this website are processed via a
                  third-party payment gateway. By making a donation, you agree
                  to our explicit{" "}
                  <a href="/refund-policy" className="text-decoration-none">
                    Refund Policy
                  </a>
                  , which states that all donations are non-refundable under any
                  circumstances.
                </p>

                <h4 className="mt-4">5. Disclaimer of Warranties</h4>
                <p>
                  The website is provided on an "as is" and "as available"
                  basis. Manav Adhikar Forum makes no representations or
                  warranties of any kind, express or implied, as to the
                  operation of the website or the information, content, or
                  materials included on this site.
                </p>

                <h4 className="mt-4">6. Limitation of Liability</h4>
                <p>
                  To the fullest extent permitted by law, Manav Adhikar Forum,
                  its directors, employees, and agents shall not be liable for
                  any direct, indirect, incidental, special, consequential, or
                  punitive damages resulting from your use of or inability to
                  use the website.
                </p>

                <h4 className="mt-4">7. Links to Third-Party Websites</h4>
                <p>
                  Our website may contain links to third-party websites that are
                  not owned or controlled by us. We have no control over, and
                  assume no responsibility for, the content, privacy policies,
                  or practices of any third-party websites.
                </p>

                <h4 className="mt-4">8. Termination</h4>
                <p>
                  We may terminate or suspend your access to the website
                  immediately, without prior notice or liability, for any reason
                  whatsoever, including without limitation if you breach the
                  Terms.
                </p>

                <h4 className="mt-4">9. Governing Law</h4>
                <p>
                  These Terms shall be governed and construed in accordance with
                  the laws of India, without regard to its conflict of law
                  provisions.
                </p>

                <h4 className="mt-4">10. Changes to the Terms</h4>
                <p>
                  We reserve the right to modify or replace these Terms at any
                  time at our sole discretion. We will provide a notice on our
                  website of any material changes. Your continued use of the
                  website after any such changes constitutes your acceptance of
                  the new Terms.
                </p>

                <h4 className="mt-4">11. Contact Information</h4>
                <p>
                  If you have any questions about these Terms, please contact us
                  at:
                  <br />
                  Email:{" "}
                  <a href="mailto:manavadhikarforumindia@gmail.com">
                    manavadhikarforumindia@gmail.com
                  </a>
                  <br />
                  Address: 2nd -FR, FL-C-3, Holding No-53, Ramkrishna Garh Road,
                  Manickpur, LP-110/31/10/1, Kolkata, West Bengal-700079
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TermsAndConditions;
